module.exports = __webpack_public_path__ + "img/brandImg0.10392610.jpg";